

























































export default {
  data() {
    return {
      // eslint-disable-next-line 
      description: `​Cleary Consolidated Central Vacuums was founded over 40 years ago by Paul "Bud" and Marlene Cleary on the south side of Indianapolis. Their philosophy then, as it is now, was to provide the best products, service and parts in the floor care industry. Their son Mike has taken over the management of the company and the tradition continues. For all your central vacuum needs in Indiana, we're the only company you need to know.`,
      secondaryDescription: `All of our employees possess years of on-the-job experience. Not only that, they're also industry certified and committed to keeping up with the latest advances in the field. You can rest easy, because your vacuum will be in the best and most skilled hands that it can be`
    }
  },
  methods: {
    routeToBids: function (): void {
      // eslint-disable-next-line 
      var that = this as any;
      that.$router.push('bids');
    }
  }
}
